import { VALUE_UPDATE_EVENT } from "../../lib/constants.js";
import { computed, createBlock, createVNode, openBlock, renderSlot, unref, withCtx, withModifiers } from "vue";
import { DtButton, DtInput, DtText, VALIDATION_MESSAGE_TYPES } from "@dialpad/dialtone-vue";
import { DtIconClose } from "@dialpad/dialtone-icons/vue";
//#region src/components/controls/control_string.vue
var _sfc_main = /* @__PURE__ */ Object.assign({ name: "DtcControlString" }, {
	props: {
		value: {
			type: String,
			default: () => String()
		},
		disabled: {
			type: Boolean,
			default: false
		},
		warning: {
			type: String,
			default: void 0
		},
		defaultValue: {
			type: String,
			default: () => String()
		}
	},
	emits: [VALUE_UPDATE_EVENT],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const isModified = computed(() => props.value !== props.defaultValue);
		const messages = computed(() => {
			const messages = [];
			if (props.warning) messages.push({
				message: props.warning,
				type: VALIDATION_MESSAGE_TYPES.WARNING
			});
			return messages;
		});
		function onReset() {
			emit(VALUE_UPDATE_EVENT, props.defaultValue);
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(DtInput), {
				"model-value": __props.value,
				disabled: __props.disabled,
				messages: messages.value,
				size: 100,
				onInput: _cache[0] || (_cache[0] = (e) => emit(unref("update:value"), e))
			}, {
				label: withCtx(() => [createVNode(unref(DtText), {
					kind: "label",
					size: 100,
					tone: "secondary",
					class: "d-input__label-text"
				}, {
					default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
					_: 3
				})]),
				endIcon: withCtx(({ iconSize }) => [isModified.value && !_ctx.$slots.icon ? (openBlock(), createBlock(unref(DtButton), {
					key: 0,
					kind: "muted",
					importance: "clear",
					size: 100,
					class: "d-p-25",
					onClick: withModifiers(onReset, ["stop"])
				}, {
					icon: withCtx(() => [createVNode(unref(DtIconClose), { size: "100" })]),
					_: 1
				})) : renderSlot(_ctx.$slots, "icon", {
					key: 1,
					iconSize
				})]),
				_: 3
			}, 8, [
				"model-value",
				"disabled",
				"messages"
			]);
		};
	}
});
//#endregion
export { _sfc_main as default };

//# sourceMappingURL=control_string.vue.js.map